var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { "justify-space-between": "", column: "", "fill-height": "" } },
    [
      _c(
        "v-list",
        { staticClass: "pa-0 pl-2", attrs: { "justify-end": "" } },
        [
          _c(
            "v-list-item-group",
            { attrs: { mandatory: "" } },
            [
              this.$store.getters["user/user"].SAPEmpId != "0000"
                ? _c(
                    "v-list-item",
                    { staticClass: "px-2" },
                    [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                right: "",
                                color: "primary",
                                disabled: _vm.mini,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-img",
                                          _vm._g(
                                            {
                                              key: _vm.pictureKey,
                                              attrs: {
                                                src: _vm.$store.getters[
                                                  "user/profilePicture"
                                                ],
                                              },
                                              on: {
                                                click: function ($event) {
                                                  !_vm.mini &&
                                                    _vm.changeUserPic()
                                                },
                                              },
                                            },
                                            _vm.mini ? {} : on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                844447600
                              ),
                            },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.$t("changePic")))]),
                              _c("input", {
                                ref: "file",
                                staticStyle: { display: "none" },
                                attrs: {
                                  type: "file",
                                  accept: "image/png, image/jpeg, image/jpg",
                                  id: "userPicFile",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.handleFileUpload()
                                  },
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-list-item-content",
                        { staticClass: "pt-1 pb-1" },
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$store.getters["user/user"].Name) +
                                " "
                            ),
                          ]),
                          _c("v-list-item-subtitle", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    _vm.$store.getters["user/user"].UserLocation
                                  )
                                ) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("closeNavigation")
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessTimeManagement &&
              this.$store.getters["user/user"].SAPEmpId != "0000"
                ? _c(
                    "v-list-item",
                    {
                      staticClass: "px-2",
                      on: {
                        click: function ($event) {
                          return _vm.changeRoute("MainMenu")
                        },
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            disabled: !_vm.mini,
                            color: "primary",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-list-item-avatar",
                                      _vm._g({ staticClass: "mr-0" }, on),
                                      [_c("v-icon", [_vm._v("mdi-alarm")])],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("timekeeping"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1835093602
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("timekeeping")))])]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessManualTimeManagement &&
              this.$store.getters["user/user"].SAPEmpId != "0000"
                ? _c(
                    "v-list-item",
                    {
                      staticClass: "px-2",
                      on: {
                        click: function ($event) {
                          return _vm.changeRoute("ManualTimekeeping")
                        },
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            disabled: !_vm.mini,
                            color: "primary",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-list-item-avatar",
                                      _vm._g({ staticClass: "mr-0" }, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-timer-edit-outline "),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("manualTimekeeping")
                                              )
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3946200464
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("manualTimekeeping"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessPresenceList &&
              this.$store.getters["user/user"].SAPEmpId != "0000"
                ? _c(
                    "v-list-item",
                    {
                      staticClass: "px-2",
                      on: {
                        click: function ($event) {
                          return _vm.changeRoute("PresenceList")
                        },
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            disabled: !_vm.mini,
                            color: "primary",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-list-item-avatar",
                                      _vm._g({ staticClass: "mr-0" }, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v(
                                            "mdi-account-box-multiple-outline"
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("presencelist"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            840022061
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("presencelist")))])]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              this.$store.getters["user/user"].SAPEmpId != "0000"
                ? _c(
                    "v-list-item",
                    {
                      staticClass: "px-2",
                      on: {
                        click: function ($event) {
                          return _vm.AbsenceDialogOpen()
                        },
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            disabled: !_vm.mini,
                            color: "primary",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-list-item-avatar",
                                      _vm._g({ staticClass: "mr-0" }, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-calendar-multiselect"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("absenceRequest"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3024495533
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("absenceRequest")))])]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              (_vm.canAccessAbsenceOverview &&
                this.$store.getters["user/user"].SAPEmpId != "0000") ||
              (_vm.canAccessAbsenceOverviewTeam &&
                this.$store.getters["user/user"].SAPEmpId != "0000")
                ? _c(
                    "v-list-item",
                    {
                      staticClass: "px-2",
                      on: {
                        click: function ($event) {
                          return _vm.changeRoute("AbsenceOverview")
                        },
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            disabled: !_vm.mini,
                            color: "primary",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-list-item-avatar",
                                      _vm._g({ staticClass: "mr-0" }, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-calendar-text-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("absenceOverview"))
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            160459278
                          ),
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("absenceOverview"))),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessUserAdministration
                ? _c(
                    "v-list-group",
                    {
                      staticClass: "cobi-rt-dn",
                      attrs: {
                        "append-icon": "mdi-chevron-right",
                        "active-class": "navigationItemListColor--text",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      right: "",
                                      color: "primary",
                                      disabled: !_vm.mini,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-list-item-avatar",
                                                _vm._g(
                                                  {
                                                    class: [
                                                      "mr-0",
                                                      _vm.mini ? "" : "ml-n2",
                                                    ],
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { size: "24" } },
                                                    [_vm._v("mdi-domain")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3571227377
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("administration"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-2" },
                                      [_vm._v(_vm._s(_vm.$t("administration")))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1733591888
                      ),
                    },
                    [
                      _vm.canAccessUserAdministration ||
                      this.$store.getters["user/user"].SAPEmpId == "0000"
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                "active-class": "navigationItemListColor--text",
                                link: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("Administration")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [_c("v-icon", [_vm._v("mdi-calendar-clock")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("timeModels")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canAccessUserAdministration
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("UserAdministration")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-account-supervisor"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("userAdministration"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canAccessUserAdministration
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("UserGroup")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [_c("v-icon", [_vm._v("mdi-account-key")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("userRights")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessManagement
                ? _c(
                    "v-list-group",
                    {
                      staticClass: "cobi-rt-dn",
                      attrs: {
                        "append-icon": "mdi-chevron-right",
                        "active-class": "navigationItemListColor--text",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      right: "",
                                      color: "primary",
                                      disabled: !_vm.mini,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-list-item-avatar",
                                                _vm._g(
                                                  {
                                                    class: [
                                                      "mr-0",
                                                      _vm.mini ? "" : "ml-n2",
                                                    ],
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { size: "24" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-account-group"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      862621186
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("management"))),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-2" },
                                      [_vm._v(_vm._s(_vm.$t("management")))]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        181127889
                      ),
                    },
                    [
                      _vm.canAccessManagement &&
                      _vm.$store.getters["server/stageProjectsAllowed"] == 1
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("ProjectManagement")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [_c("v-icon", [_vm._v("mdi-account-details")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("projectManagement"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canAccessManagement &&
                      _vm.$store.getters["server/serviceCallsAllowed"] == 1
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute(
                                    "ServiceCallManagement"
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [_c("v-icon", [_vm._v("mdi-layers-edit")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("serviceCalls")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessGeneralReporting || _vm.canAccessGeneralReportingTeam
                ? _c(
                    "v-list-group",
                    {
                      staticClass: "cobi-rt-dn",
                      attrs: {
                        "append-icon": "mdi-chevron-right",
                        "active-class": "navigationItemListColor--text",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: {
                                      right: "",
                                      color: "primary",
                                      disabled: !_vm.mini,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-list-item-avatar",
                                                _vm._g(
                                                  {
                                                    class: [
                                                      "mr-0",
                                                      _vm.mini ? "" : "ml-n2",
                                                    ],
                                                  },
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { attrs: { size: "24" } },
                                                    [
                                                      _vm._v(
                                                        "mdi-chart-timeline"
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3954005323
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("generalReporting"))
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "body-2" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("generalReporting"))
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4129676802
                      ),
                    },
                    [
                      _vm.canAccessGeneralReporting ||
                      _vm.canAccessGeneralReportingTeam
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("TimeReport")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-timeline-clock-outline"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("worktime")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canAccessGeneralReporting ||
                      _vm.canAccessGeneralReportingTeam
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("AbsenceReport")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-badge-account-alert-outline"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("absence")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canAccessGeneralReporting ||
                      _vm.canAccessGeneralReportingTeam
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                "active-class": "navigationItemListColor--text",
                                link: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("TimeReports")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [_c("v-icon", [_vm._v("mdi-file-chart")])],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("timeReport")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.canAccessGeneralReporting ||
                      _vm.canAccessGeneralReportingTeam
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "pl-8",
                              attrs: {
                                link: "",
                                "active-class": "navigationItemListColor--text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.changeRoute("Statistics")
                                },
                              },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                { staticClass: "mr-0" },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-chart-box-outline"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "body-2" },
                                    [_vm._v(_vm._s(_vm.$t("statistics")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.canAccessUserAdministration ||
              this.$store.getters["user/user"].SAPEmpId == "0000"
                ? _c(
                    "v-list-item",
                    {
                      staticClass: "px-2",
                      on: {
                        click: function ($event) {
                          return _vm.changeRoute("Settings")
                        },
                      },
                    },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            right: "",
                            color: "primary",
                            disabled: !_vm.mini,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-list-item-avatar",
                                      _vm._g({ staticClass: "mr-0" }, on),
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-cog-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      _vm._g({}, on),
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "body-2" },
                                          [_vm._v(_vm._s(_vm.$t("settings")))]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            2671639554
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("settings")))])]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-spacer"),
      _c(
        "v-list",
        { staticClass: "pb-0 pl-2", attrs: { "justify-end": "" } },
        [
          _c("v-divider", { staticStyle: { "border-width": "1px" } }),
          _c(
            "v-list-item",
            {
              staticClass: "px-0",
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { right: "", disabled: !_vm.mini, color: "primary" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on }) {
                        return [
                          _c(
                            "v-list-item-avatar",
                            _vm._g({ staticClass: "mr-0" }, on),
                            [_c("v-icon", [_vm._v("mdi-logout-variant")])],
                            1
                          ),
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "body-2" },
                                [_vm._v(_vm._s(_vm.$t("logout")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("logout")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.ShowAbsenceDialog
        ? _c("AbsenceDialog", {
            attrs: {
              CanSendAbsence: false,
              User: _vm.$store.getters["user/user"],
            },
            on: {
              close: function ($event) {
                _vm.ShowAbsenceDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }